import { useRouteMatch } from 'react-router-dom';

export const useRouteHelper = () => {
  const inPolicyRoute = !!useRouteMatch({ path: '/customer/:id/policy/:policyId' })?.isExact;
  const inOfferEditRoute = !!useRouteMatch({ path: '/offer/:offerId' })?.isExact;
  const inUWFormRoute = !!useRouteMatch({ path: '/offer/:offerId/verifyUW' })?.isExact;
  const inOfferCheckoutRoute = !!useRouteMatch({ path: '/offer/:offerId/:option/checkout' })?.isExact;
  const inCustomerRoute = !!useRouteMatch({ path: '/customer/:id' })?.isExact;
  const inNewQuoteRoute = !!useRouteMatch({ path: '/quote' })?.isExact;
  const inToolsRoutes = !!useRouteMatch({ path: '/staff/tools' });
  const inSearchOffers = !!useRouteMatch({ path: '/search/offers' })?.isExact;
  const inSearchCustomers = !!useRouteMatch({ path: '/search/customers' })?.isExact;
  const inSearchPolicies = !!useRouteMatch({ path: '/search/policies' })?.isExact;
  const inAgencyPortal = !!useRouteMatch({ path: '/portal' });
  const inSignInRoute = !!useRouteMatch({ path: '/signin' })?.isExact;
  const inBranchPlusPolicy = !!useRouteMatch({ path: '/branch-plus/:policyId' })?.isExact;

  return {
    inPolicyRoute,
    inOfferEditRoute,
    inUWFormRoute,
    inOfferCheckoutRoute,
    inCustomerRoute,
    inNewQuoteRoute,
    inToolsRoutes,
    inSearchOffers,
    inSearchCustomers,
    inSearchPolicies,
    inAgencyPortal,
    inSignInRoute,
    inBranchPlusPolicy
  };
};
